import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tip',
  pure: false
})
export class TipPipe implements PipeTransform {


  transform(items: any[], text: string): any {

   // text = text.toLocaleLowerCase();
      if(!text ){
        return items
      }

      return items.filter(item => {
        item = item.obiettivi.includes(text);

        return item;
      });


  }

}
